(function () {
  var CLOSE_DELAY_MS = 220;

  function initCommercialNav() {
    var toggle = document.querySelector('[data-cp-nav-toggle]');
    var drawer = document.querySelector('[data-cp-nav-drawer]');
    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        var open = drawer.hasAttribute('hidden');
        if (open) {
          drawer.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          drawer.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    var isDesktop = window.matchMedia('(min-width: 990px)').matches;

    document.querySelectorAll('.cp-header__dropdown').forEach(function (dropdown) {
      var trigger = dropdown.querySelector('.cp-header__link--trigger');
      if (!trigger) return;

      var closeTimer;

      function openDropdown() {
        clearTimeout(closeTimer);
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }

      function closeDropdown() {
        closeTimer = setTimeout(function () {
          dropdown.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY_MS);
      }

      function closeDropdownNow() {
        clearTimeout(closeTimer);
        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }

      if (isDesktop) {
        dropdown.addEventListener('mouseenter', openDropdown);
        dropdown.addEventListener('mouseleave', closeDropdown);
        dropdown.addEventListener('focusin', openDropdown);
        dropdown.addEventListener('focusout', function (event) {
          if (!dropdown.contains(event.relatedTarget)) {
            closeDropdown();
          }
        });
      }

      trigger.addEventListener('click', function (event) {
        if (isDesktop) return;
        event.preventDefault();
        var isOpen = dropdown.classList.contains('is-open');
        document.querySelectorAll('.cp-header__dropdown.is-open').forEach(function (openDropdown) {
          openDropdown.classList.remove('is-open');
          var openTrigger = openDropdown.querySelector('.cp-header__link--trigger');
          if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          openDropdown();
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.cp-header__dropdown')) {
        document.querySelectorAll('.cp-header__dropdown.is-open').forEach(function (dropdown) {
          dropdown.classList.remove('is-open');
          var trigger = dropdown.querySelector('.cp-header__link--trigger');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initCommercialNav);
})();
